// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalendarFilledSvg from "@ant-design/icons-svg/es/asn/CalendarFilled";
import AntdIcon from '../components/AntdIcon';

var CalendarFilled = function CalendarFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarFilledSvg
  }));
};

CalendarFilled.displayName = 'CalendarFilled';
export default React.forwardRef(CalendarFilled);